import React, { useEffect, useState } from 'react';
import './donorItem.scss';
import { env } from '../../../../../../environment';
import moment from 'moment';
import _ from 'lodash';
import { withTranslation } from 'react-i18next';
import { parseFloatByLanguage, renderRegionName } from '../../../../../../utils/functionCommon';

const DonorItemComponent = (props: any) => {
  const { item, subscription, token, t } = props;

  const [caclValues, setCaclValues] = useState({
    amount: item.donation_money,
    area: item.area,
    co2: item.amount_kg_co2,
  });

  useEffect(() => {
    if (subscription) {
      const sumAmount = _.sumBy(item.sub_donations || [], 'donation_money');

      const sumArea = _.sumBy(item.sub_donations || [], 'area');

      const sumCo2 = _.sumBy(item.sub_donations || [], 'amount_kg_co2');

      setCaclValues({
        amount: (item.donation_money || 0) + (sumAmount || 0),
        area: (item.area || 0) + (sumArea || 0),
        co2: (item.amount_kg_co2 || 0) + (sumCo2 || 0),
      });
    }
  }, []);

  const renderItemRight = (item: any) => {
    return moment(item.payment_date).format('DD.MM.YYYY');
  };

  return (
    <div className="donor-item">
      <div className="donor-item-contaner">
        <div className="donor-image">
          <a className="label" href={`/donor-portal/${token}/donation/${item.id}?lang=${t('language')}`}>
            <div className="donor-image-container">
              <img src={`${env.IMAGE_URL}/${item.header_picture}`} alt={renderRegionName(item.campaign_name || item.region_name)} loading="lazy" />
            </div>
          </a>
          <div className="donor-item-header">
            <div className="item-header">
              <div className="item-header-container">
                <div className="item-code item-value">
                  {'#'}
                  {item.serial}
                </div>
                <div className="item-date item-value">{renderItemRight(item)}</div>
              </div>
            </div>
            <div className="donor-name">
              <div className="donor-name-container">
                <div className="name">{renderRegionName(item.campaign_name || item.region_name)}</div>
                <div className="icon-map-container">
                  <a className="icon-map" href={item.map_url} target="_blank" rel="noreferrer">
                    <i className="fa-solid fa-map-location-dot"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="donor-content-item">
          <p className="item-content-text">
            {t('my_donation_description_1')}{' '}
            <span className="text-value">
              {parseFloatByLanguage(caclValues.amount, t('language'), 2, 2)} {item.currency_unit || '€'}
            </span>
            {t('my_donation_description_2')}{' '}
            <span className="text-value">
              {parseFloatByLanguage(caclValues.area, t('language'))} m<sup>2</sup>
            </span>{' '}
            {t('my_donation_description_3')}{' '}
            <span className="text-value">
              {parseFloatByLanguage(caclValues.co2, t('language'))} kg CO<sub>2</sub>
            </span>
            , {t('my_donation_description_4')}
          </p>
        </div>
        <div className="donor-item-actions">
          <div className="actions-container">
            <div className="action-left"></div>
            <div className="action-right">
              <div>
                {' '}
                <a className="label" href={`/donor-portal/${token}/donation/${item.id}?lang=${t('language')}`}>
                  {t('details')} <i className="fa-solid fa-angle-right"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default withTranslation('language')(DonorItemComponent);
